import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface ServiceEmptyStateProps {
  onAddNewService: () => void;
}

export const ServiceEmptyState = ({ onAddNewService }: ServiceEmptyStateProps) => {
  const { t } = useTranslation();

  return (
    <div className="text-center py-12 px-4 border border-dashed border-gray-200 rounded-lg">
      <h3 className="text-lg font-medium text-gray-900 mb-2">{t('services.noServicesYet')}</h3>
      <p className="text-gray-500 mb-4">{t('services.createFirstService')}</p>
      <Button 
        onClick={onAddNewService}
        variant="gradient"
      >
        {t('services.createService')}
      </Button>
    </div>
  );
};
